<div class="card">
  <div class="card-header">
    <h3>{{ 'findings_by_severity' | translate }}</h3>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <span class="visually-hidden" aria-live="polite" id="severityChartAriaLabel">
          {{ getChartAriaLabel() }}
        </span>
        <div id="severityChart" [attr.aria-hidden]="true" class="graph w-100" aria-labelledby="severityChartAriaLabel"></div>
      </div>
    </div>
  </div>
</div>
